<template>
      <div>
        <b-icon icon="x-octagon" variant="danger" animation="throb" font-scale="8" />
        <hr>
        <h3 class="mb-0">  {{$t('general.sure')}} </h3>
        <p> {{$t('general.deleteMsg')}}</p>
        <div v-if="input.length > 0">
            <p> {{$t('account.deleteAccountMsg')}}  </p>
            <b-input :placeholder="$t('account.deleteAccountMsg2')" v-model="name" @input="changeVal(name)" />
        </div>
   </div>
</template>

<script>
    export default {
        name: "AccountDelete",
        data:function(){
            return{
                name: ""
            }
        },
        props:{
            data: Object,
            save: Boolean,
            input: Array,
            sendRequest: Function,
            changeVal: Function,
        },
        watch:{
            save: async function(data){
                if(data){
                    this.sendRequest();
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Dealer/modals/Delete.vue